import './Footer.css';

const Footer = () => (
  <footer className='footer'>
    <a
      href={'https://www.linkedin.com/in/swati17/'}
      target='_blank'
      rel='noreferrer'
      className='link footer__link'
    >
      Built by Swati Saxena
    </a>
  </footer>
);

export default Footer;
